module.exports = __webpack_public_path__ + "static/media/25_negro.336ea042.svg";